<template>
  <div>
    <h1>Login</h1>
    <form>
        <label for="username" >Username</label>
        <div>
          <input id="username" type="username" v-model="username" required autofocus>
        </div>
        <div>
            <label for="password" >Password</label>
            <div>
              <input id="password" type="password" v-model="password" required>
            </div>
        </div>
        <div>
          <p class="error" v-if="error">{{ error }}</p>
          <!-- <button type="submit" @click="handleSubmit">Login</button> -->
          <button type="submit" @click="loginValidate">Login</button>
        </div>
    </form>
    <div class="user-info">
        <h2>Login information</h2>
        <p>The following logins can be used to test out the functionality.</p>
        <p>user: rmanning <br> pass: password<br></p>
        <p>user: jsmith <br> pass: password</p>
    </div>
  </div>
</template>

<script>
  import PostService from '../PostService'
  export default {
    data(){
      return {
        username : "",
        password : "",
        error: ""
      }
    },
    methods : {
      async loginValidate(e) {
        e.preventDefault();
        await PostService.checkUser(this.username, this.password);
        this.$router.push('/');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue